import { useTranslation } from 'react-i18next';
import Markdown from 'react-markdown';
import { Box, Typography } from '@mui/material';

import { PAGE_TYPES } from 'src/constants/module';
import useSimpleContentPage from 'src/hooks/useSimpleContentPage';
import TextSkeleton from 'src/components/common/LoadingPage/textSkeleton';
import PageFrame from 'src/components/common/PageFrame';

import { styles } from './index.styles';

export const CHATBOT_TERMS_PAGE_TEST_ID = 'chatbot-terms-page';

export const ChatbotTermsPage = () => {
  const { t } = useTranslation('chatbot');
  const { pageContent, error, loading } = useSimpleContentPage(
    PAGE_TYPES.CHATBOT_TERMS,
  );

  return (
    <PageFrame>
      {loading ? (
        <TextSkeleton />
      ) : error ? (
        <Typography color="error" sx={{ fontSize: 'large' }}>
          {error}
        </Typography>
      ) : (
        <>
          <Typography
            variant="h2"
            data-test-id={CHATBOT_TERMS_PAGE_TEST_ID}
            sx={{ my: 1.5 }}
          >
            {t('chatbotTerms')}
          </Typography>
          <Box sx={styles.wrapperStyles}>
            <Markdown>{pageContent}</Markdown>
          </Box>
        </>
      )}
    </PageFrame>
  );
};

export default ChatbotTermsPage;
